/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>积分商城</el-breadcrumb-item> -->
       <el-breadcrumb-item
        style="cursor: pointer"
        @click.native="breadcrumbClick(item.id, index, item)"
        v-for="(item, index) in breadcrumbList"
        :key="item.id"
        >{{ item.name }}</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="breadcrumbList.length == 1 ? true : false"
        >所有</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container class="filter_con">
      <el-header class="fisrtNav">
        <el-row>
          <el-col :span="2">
            <span class="labelTitle" v-if="categorylists.length!=0?true:false">分类：</span>
          </el-col>
          <el-col :span="22" class="labelcontent" >
            <a
              class="OneLineDisplay"
              :title="item.name"
              style="width: 10%; display: inline-block; margin-bottom: 10px"
               v-for="(item,index) in categorylists" :key="index"               
               @click="getCategorylist(item.bxscId,item.name)"
              >{{item.name}}
            </a>

          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"> </el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-main class="rightaside">
          <el-row class="right_product" :gutter="20" v-loading="loading">
            <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6">
              <div class="product_item selectItemCss_ls">
                  <div class="product_item_whole">
                      <div class="p-img">
                        <router-link
                          :to="`/pointsProDetails?id=${item.specificationid}`"
                          class="item_link"
                        >
                          <el-image
                            class="img-responsive"
                            :src="item.commodity.photos.indexOf(',')>0?item.commodity.photos.split(',')[0]:item.commodity.photos"
                            style="display: block"
                          ></el-image>
                        </router-link>
                      </div>
                    <div class="goodsBottom">
                        <div class="pro_name">
                          <p class="OneLineDisplay">{{item.commodity.name}}</p>
                        </div>
                        <div class="pro_price_add">
                          <span style="color: #f10214">积分{{item.activityPointsNum || 0}} + ¥{{item.itemDiscountPrice}}元</span>
                          <span style="text-decoration: line-through;color: #8c8c8c;">¥{{item.commodity.price || 0}}</span>                    
                        </div>
                        <div class="remaining">
                          <span>剩余 {{item.activityPointsProductNum||0}}</span>               
                        </div>
                    </div>  
                  </div>
                  <div class="mark">
                      <div class="redeemNow" @click="$router.push(`/pointsProDetails?id=${item.specificationid}`)">
                          立即兑换
                      </div> 
                  </div>                  
              </div>
        </el-col>
          </el-row>
		  <el-row>
		  	<div class="nodate" v-if="rightGoodsList.length>0?false:true">
		  		<div class="first">对不起，对应商品分类或筛选组合下没有商品!</div>
		  	</div>
		  </el-row>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import hotGoods from '@/components/hotGoods'
import "@/assets/css/base.css";
import { commoditylist,addShoppingCart,categorylist,presentlist } from "@/api/xunyou";
import pointMallData from './pointMall.json'
// import '@/assets/xunyou/css/layui.css'
// import '@/assets/bootstrap.min.csss'
// arr.slice(2,4)
export default {
  data() {
    return {
      breadcrumbList: [{ id: 1, name: "首页", url: "/" },{ id: 0, name: "所有", url: "/pointMall" }], //面包屑数组
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      loading:false,
      centerDialogVisible: false,
      successInfo: true,
      categorylists:[],
      addGoodsName: "",
      checked1: "",
	    checked2: "",
      rightGoodsList:[],
      hotGoodsTitle:'热卖商品',
    };
  },
  // 注册组件
  components: {hotGoods},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
    // this.getCommoditylist()
    this.getCategorylist()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
     // 面包屑点击事件
    breadcrumbClick(id, index, item) {
      console.log(id, index, item,'面包屑点击事件=============')
      // debugger
      if (id == 1) {
        // 说明是首页 文字
        this.$router.push("/");
      }
      // let key = this.breadcrumbList.findIndex(v=>v.name==item.name)
      let key = this.breadcrumbList.length - 1;
      if (index == key) {
        return;
      }
      this.breadcrumbList.forEach((value, key) => {
        if (value.id == id) {
          this.breadcrumbList = this.breadcrumbList.slice(0, index + 1);
          this.getCategorylist(id,'');
        }
      });
    },

    // 商品列表分类    
    getCategorylist(id,name) {
      console.log("商品列表分类查询");
       // 记录到面包屑数组里
      if (name != "" && name != undefined) {
        let breadObj = {
          id: id,
          name: name,
          url: `/pointMall`,
        };
        this.breadcrumbList.push(breadObj);
      }
      categorylist({
        parentBxscId:id||0
      })
        .then((res) => {
          //   if (res.code == 0) {
          console.log("res", res);
         this.categorylists = res
         this.getCommoditylist(id)

        })
        .catch((err) => {
          this.$message.error("查询商品分类失败，请稍后再试！");
        });
    },
     // 积分商品列表查询
    getCommoditylist(id) {
      this.loading = true;
      presentlist({
        cid:id||'', // 商品分类
        mallUserId:this.userInfo.userId || ''
      })
        .then((res) => {
          //   if (res.code == 0) {
          this.loading = false;
          this.rightGoodsList = res.rows
         
        })

      // this.loading = true;
      // commoditylist({
      //   cid:id||''
      // })
      //   .then((res) => {
      //     //   if (res.code == 0) {
      //     console.log("res商品列表查询", res);
      //     this.loading = false;
      //     this.rightGoodsList = res.rows;
      //     this.lefthotGoodsList = res.rows>4? res.rows.slice(0,4):res.rows
         
      //   })
      //   .catch((err) => {
      //     this.loading = false;
      //     this.$message.error("查询商品列表失败，请稍后再试！");
      //   });
    },
    addCart(id,name,specificationlist) {
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
      addShoppingCart({
        cid: id,
        uid: 1,   
        number: 1,
        bxysid:specificationlist.length>0?specificationlist[0].bXySid:''
      })
        .then((res) => {
            if (res.code == 0) {            
              console.log("res", res);
              this.addGoodsName = name;
              this.centerDialogVisible = true;
          
            }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("添加购物车失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
.labelTitle {
  text-align: left;
  padding-left: 15px;
  font-weight: bold;
  color: #666;
  font-size: 14px;
}
.labelcontent {
}
.fisrtNav {
  padding: 10px 0px;
  border-top: 1px dashed #ddd;
  border-bottom: 1px dashed #ddd;
  margin-bottom: 20px;
}
.leftaside {
  /* background: pink; */
  /* padding: 10px; */
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
}
.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
.left_product {
  padding: 10px;
}
.left_product li {
  margin-bottom: 30px;
}
.pro-price {
  margin: 10px 0;
  color: #78b942;
}
.pro_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  margin: 10px 0;
  height: 40px;
}
.img-responsive {
  width: 100%;
  // width: 200px;
  height: 200px;
}
.rightaside {
  /* background: yellow; */
  padding: 0px;
  box-sizing: border-box;
  overflow: hidden;
}
.el-header {
  height: auto !important;
}

/* 右边 */
.orderby {
  width: 100%;
  padding: 8px 0;
  background: #f1f1f1;
}
.orderby ul {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.orderby ul li {
  background: #fff;
  color: #333;
  margin-left: 10px;
  border: 1px solid #ddd;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 20px;
}
.active {
  background: #78b942 !important;
  font-weight: bold;
}
.active a {
  color: white !important;
}
.orderby .el-checkbox__label {
  font-size: 12px !important;
}
.orderby .el-checkbox__input {
  vertical-align: bottom !important;
}
.right_product {
  padding: 20px;
}
.right_product .product_item {
  margin-bottom: 20px;
  border: 1px solid #fff;
  border-color: #e9e9e9;
  -webkit-box-shadow: 0 0 2px 2px #f8f8f8;
  box-shadow: 0 0 2px 2px #f8f8f8;
  padding: 10px;
  box-sizing: border-box;
  position: relative;
  .product_item_whole{
    // position:absolute;
  }
  .mark{
    position: absolute;
    top: 65%;
    width: 255px;
    height: 33%;
    font-size: 16px;
    background: rgba(255, 255, 255, 0.8);
    display: none;
    .redeemNow {
        position: absolute;
        bottom: 35%;
        left: 30%;
        background: coral;
        border-radius: 50%;
        padding: 6px;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        color: white;
        background-color: rgba(34, 34, 34, 0.65);
        cursor: pointer;
    }
    .redeemNow:hover{
      background-color: rgba(34, 34, 34, 0.85);
    }
  }
}
.product_item:hover img {
  opacity: 0.7;
}
.pro_price_add {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 6px;
}
.remaining {
    font-size: 16px;
}
.cart.add-to-cart,
div.now_price {
  flex: 1;
  font-weight: bold;
  border: 1px solid #78b942;
  padding: 8px 0;
  text-align: center;
}
/* .cart.add-to-cart:hover{
	border: 1px solid #78b942;
} */
div.now_price {
  color: white;
  background: #78b942;
  border: 1px solid #78b942;
}
.dialog-footer {
  margin-top: 20px;
  display: block;
}
.addGoodsInfo {
  font-size: 24px;
}
.addCartBox .el-button--primary {
  color: #fff;
  background-color: #78b942;
  border-color: #e65d00;
}

.more_filter {
  width: 100%;
  text-align: center;
  border-top: 1px dashed #ddd;
  margin-top: -1px;
}
.more_filter:hover {
  border-color: #e13c41;
}
.more_filter span {
  display: inline-block;
  height: 30px;
  line-height: 26px;
  margin-top: -1px;
  width: 130px;
  text-align: center;
  border-width: 1px;
  border-style: dashed;
  border-color: #fff #ddd #ddd;
  background: #fff;
  font-size: 12px;
  color: #939393;
  cursor: pointer;
}
.filter_con .more_filter span i {
  font-size: 12px;
}
.filter_con .more_filter:hover span {
  color: #e13c41;
  border-color: #fff #e13c41 #e13c41;
}
.nodate{
    text-align: center;
    margin: 10% 0;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}
// .goodsBottom:hover{
//     background: rgba(255, 255, 255, 0.8);
// }
.product_item:hover {
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.15);
    .mark{
      display: block;
    }
}
// .redeemNow{
//   width: 50px;
//   height: 50px;
//   background: coral;
//   position: absolute;
// }
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pointMall/pointMall.vue